export enum ArchiveStatus {
  ARCHIVED = 'ARCHIVED',
  UNARCHIVED = 'UNARCHIVED',
}
